import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CreateInvoice from "./CreateInvoice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { LINEAR_GRADIENT_BG } from "../../constants";
import ReportStockSalePage from "./ReportStockSalePage";
// import { useLocation } from "react-router-dom";
// import Refunded from "./refunded";
import RefundedPage from "./refunded";

const OrderSalePageTab = () => {
    const [activeTab, setActiveTab] = useState("orders");

    // Handle tab change
    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    return (
        <div className="inventory-container">
            <div style={{ padding: "0 1em" }}>
                {/* //TODO HeaderTitle */}
                <div
                    className="live-list"
                >
                    <div className="baner">
                        <FontAwesomeIcon
                            icon={faFileInvoice}
                            style={{
                                width: "24px",
                                height: "24px",
                                marginRight: "10px",
                            }}
                        />
                        <span style={{ fontSize: "20px" }}>ຈັດການອໍເດີ ແຊວເພຈ </span>
                    </div>
                    <p>
                        ລາຍການອໍເດີ້ ຈາກເຊວເພຈ ແລະ ມາຈາກ ອາຟຣິລີເອດ ນາຍໜ້າຂາຍ
                    </p>
                </div>

                <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabChange}
                    className="mb-3 invoice-tabs"
                    style={{ borderBottom: "none" }}
                >
                    <Tab
                        eventKey="orders"
                        title="ອໍເດີ"
                        tabClassName="invoice-tab"
                    >
                        {activeTab === "orders" && <CreateInvoice />}
                    </Tab>
                    <Tab
                        eventKey="stock"
                        title="ສິນຄ້າ"
                        tabClassName="invoice-tab"
                    >
                        {activeTab === "stock" && <ReportStockSalePage />}
                    </Tab>
                    <Tab
                        eventKey="refunded"
                        title="ອໍເດີຍົກເລີກ"
                        tabClassName="invoice-tab"
                    >
                        {activeTab === "refunded" && <RefundedPage  />}
                    </Tab>
                </Tabs>
            </div>

            <style>{`
                .invoice-tabs .nav-link {
                color: #6B7280;
                font-weight: 500;
                border: none;
                padding: 0.5rem 1rem;
                margin-right: 1rem;
                background: transparent;
                }
                .invoice-tabs .nav-link.active {
                color: #fff;
                background: ${LINEAR_GRADIENT_BG};
                border-radius: 4px;
                }
                .invoice-tab {
                transition: all 0.3s ease;
                }
            `}</style>
        </div>
    );
};

export default OrderSalePageTab;